// Coded by Narain on (11/09/2024)

const brandImages = [
  'brand1.png', 'brand2.png', 'brand3.png', 'brand4.png', 
  'brand5.png', 'brand6.png', 'brand7.png', 'brand8.png', 
  'brand9.png', 'brand10.png', 'brand11.png', 'brand12.png'
];

const brands = brandImages.map((image, index) => ({
  image: require(`../assets/images/landing/brands/${image}`),
  title: `Brand ${index + 1}`,
  description: `Description for Brand ${index + 1}.`,
  alt: `Brand ${index + 1}`
}));

export default brands;
